<div class="error-wrap">
  <i class="warn-icon k-icon k-font-icon k-i-warning"></i>

  <span #ref><ng-content></ng-content></span>
  <span *ngIf="!ref.innerHTML.trim()">
    <strong>Sorry, HUNTER has encountered an error.</strong>
    Please return to <a routerLink="/research">Research</a> or contact
    <a routerLink="/customer-support">support</a>
  </span>
</div>
